<template>
    <div class="partner-info">
        <div class="partners-header">
            <div class="partners-header-fluid">
                <div class="partners-header-title container">
                    <h1>Parceiros</h1>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="content-brand">
                <GoToBackButton />
                <div class="content-brand-elements d-none d-lg-block">
                    <router-link
                        tag="a"
                        :to="{ name: 'Home' }"
                        class="content-brand-elements-links"
                    >
                        Ínicio
                    </router-link>
                    <span> > </span>
                    <router-link
                        tag="a"
                        :to="{ name: 'PartnersInfo' }"
                        class="content-brand-elements-links"
                    >
                        Parceiros
                    </router-link>
                </div>
            </div>
        </div>
        <div class="content-marketplace container">
            <h1>Porquê vender no Marketplace GERAS?</h1>
            <div class="row content-marketplace-itens-item">
                <div
                    class="col-md-6 content-marketplace-itens-item"
                    v-for="(partner, index) in partners.vantagens"
                    :key="index"
                >
                    <div class="content-marketplace-itens-item-img">
                        <img
                            class="img-fluid"
                            :src="setPathImage(partner.icone)"
                            alt="image benefits"
                            title="image benefits"
                        />
                    </div>
                    <h5>{{ partner.title }}</h5>
                    <p>{{ partner.descricao }}</p>
                </div>
            </div>
        </div>
        <div class="access">
            <div class="row content-access container">
                <div class="col-md-6 content-access-itens">
                    <h5>Faça parte da rede de <br />vendedores da GERAS</h5>
                    <router-link
                        :to="{ name: 'Contact' }"
                        tag="button"
                        class="btn-cadastro"
                        >Contacte-nos</router-link
                    >
                </div>
                <div class="col-md-6 content-access-itens">
                    <h5>Já sou parceiro aceda aqui <br />à sua Área Pessoal</h5>
                    <a :href="redirectBackend()" class="btn-cadastro btn-login"
                        >Entrar</a
                    >
                </div>
            </div>
        </div>
        <div class="frequents-questions">
            <div class="box-content container">
                <router-link
                    class="box-content-btn d-lg-none"
                    tag="button"
                    :to="{ name: 'FaqParterns' }"
                    >saber mais</router-link
                >
                <div class="frequents-questions-img">
                    <img
                        class="img-fluid"
                        :src="setPathImage(partners.imagem_market)"
                        alt="image partner info"
                        title="image partner info"
                    />
                </div>
                <div class="frequents-questions-text">
                    <h1>Perguntas frequentes</h1>
                    <p>{{ partners.faq_description }}</p>
                    <router-link
                        class="d-none d-lg-block"
                        tag="button"
                        :to="{ name: 'FaqPartners' }"
                        >saber mais</router-link
                    >
                </div>
            </div>
        </div>
        <div class="content-adhesion container">
            <div class="content-adhesion-title">
                <h1>Comece as suas vendas já!</h1>
            </div>
            <FormAdhesion :categories="categories" />
        </div>
        <div class="container">
            <div class="content-brand d-flex align-flex-start">
                <GoToBackButton />
            </div>
        </div>
    </div>
</template>
<script>
import FormAdhesion from "../components/FormAdhesion.vue";
import axios from "axios";
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";

export default {
    data() {
        return {
            partners: [],
            categories: {},
        };
    },
    components: {
        FormAdhesion,
        GoToBackButton,
    },
    methods: {
        setPathImage(nameImage) {
            var host = window.location.origin;
            var path = `${host}/storage/app/media/${nameImage}`;
            return path;
        },
        redirectBackend() {
            var host = window.location.origin + "/backend";
            return host;
        },
    },
    mounted() {
        axios
            .get("/api/v1/company/marketplace")
            .then((resp) => {
                console.log("COMPANY MARKETPLACE", resp.data);
                this.categories = resp.data.categories;
                this.partners = resp.data.marketing[0];
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
</script>
<style lang="scss" scoped>
.partner-info {
    padding: 100px 0 40px 0px;
    @media screen and (max-width: 991px) {
        padding: 0;
        padding-bottom: 30px;
    }
    .content-brand {
        @media (max-width: 991px) {
            padding: 0px 20px;
        }
        .btn-return {
            margin: 0 auto 0 0;
        }
    }
}
.partners-header {
    width: 100%;
    height: 250px;
    padding: 0;
    margin-bottom: 55px;
    background-image: url("~@/assets/img/partners/header-partners-info.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    @media screen and (max-width: 991px) {
        margin-bottom: 30px;
        height: 160px;
    }
    &-fluid {
        width: 100%;
        height: 100%;
        background-color: rgba(51, 133, 69, 0.35);
    }
    &-title {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 576px) {
            justify-content: flex-start;
        }
        h1 {
            font-size: 50px;
            color: var(--white);
            font-family: "Font Bold";
            @media screen and (max-width: 991px) {
                font-size: 30px;
            }
        }
    }
}
.content-marketplace {
    margin-top: 5rem;
    margin-bottom: 5rem;
    @media screen and (max-width: 991px) {
        margin-top: 3rem;
        margin-bottom: 3rem;
    }
    h1 {
        text-align: left;
        font-size: 40px;
        font-family: "Font Bold", sans-serif;
        color: var(--green-medium);
        margin-bottom: 6.5rem;
        @media screen and (max-width: 991px) {
            font-size: 24px;
            padding: 0px 20px;
            margin-bottom: 2.5rem;
        }
    }
    &-itens {
        gap: 20px;
        &-item {
            text-align: left;
            margin: 2rem 0;
            @media screen and (max-width: 991px) {
                flex: 0 0 100%;
                max-width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                text-align: justify;
            }
            &-img {
                height: 100px;
                display: flex;
                align-items: flex-end;
                padding: 1rem 0;
            }
            h5 {
                font-size: 24px;
                font-family: "Font Semibold";
                color: var(--green-medium);
                margin: 1rem 0;
            }
            p {
                font-family: "Font Regular";
                font-size: 22px;
                color: var(--green-dark);
                margin: 0;
                @media screen and (max-width: 991px) {
                    font-size: 22px;
                }
            }
        }
    }
}
.access {
    width: 100%;
    height: 360px;
    background-color: #f3f8f4;
    display: flex;
    justify-content: center;
    @media screen and (max-width: 991px) {
        height: auto;
    }
}
.content-access {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 30px 20px;
    @media screen and (max-width: 991px) {
        flex-direction: column;
        gap: 5.5rem;
        padding: 40px 0;
    }
    &-itens {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &:first-child {
            border-right: 1px solid #707070;
            @media (max-width: 991px) {
                border-right: 0;
            }
        }
        h5 {
            font-family: "Font Regular", sans-serif;
            font-size: 30px;
            color: var(--green-medium);
            line-height: 2;
            margin-bottom: 30px;
            @media screen and (max-width: 991px) {
                font-size: 24px;
                line-height: 1.2;
            }
        }
        button,
        a {
            all: unset;
            background: var(--green-medium);
            border: 1px solid var(--green-medium);
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
            border-radius: 10px;
            color: #fff;
            width: 222px;
            height: 72px;
            font-family: "Font Regular";
            font-size: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
                margin: 0;
            }
            &:hover,
            &:focus {
                cursor: pointer;
                background: var(--white);
                color: var(--green-medium);
            }
        }
        .btn-login {
            width: 192px;
        }
    }
}
.frequents-questions {
    margin-top: 14rem;
    width: 100%;
    height: 460px;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    @media screen and (max-width: 991px) {
        height: auto;
        flex-direction: column;
        gap: 0;
        margin-top: 0;
    }
    .box-content {
        @media screen and (max-width: 991px) {
            width: 100%;
            max-width: 100%;
            padding: 0;
            height: 100%;
            display: flex;
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
            button {
                all: unset;
                background: var(--green-medium);
                border: 1px solid var(--green-medium);
                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
                border-radius: 10px;
                color: #fff;
                width: 160px;
                height: 60px;
                font-family: "Font Regular", sans-serif;
                font-size: 22px;
                text-align: center;
                p {
                    margin: 0;
                }
                &:hover,
                &:focus {
                    cursor: pointer;
                    background: var(--white);
                    color: var(--green-medium);
                }
            }
        }
    }
    &-text {
        flex: 0 0 50%;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        gap: 3rem;
        @media screen and (max-width: 991px) {
            flex: 0 0 100%;
            width: 100%;
            align-items: flex-start;
            justify-content: center;
            padding: 40px 30px;
            gap: 0;
        }
        h1 {
            font-family: "Font Bold", sans-serif;
            font-size: 40px;
            color: var(--green-medium);
            @media screen and (max-width: 991px) {
                font-size: 24px;
                margin-bottom: 15px;
            }
        }
        p {
            font-family: "Font Regular";
            font-size: 28px;
            color: var(--green-dark);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            @media screen and (max-width: 991px) {
                font-size: 18px;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        button {
            all: unset;
            background: var(--green-medium);
            border: 1px solid var(--green-medium);
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
            border-radius: 10px;
            color: #fff;
            width: 160px;
            height: 60px;
            font-family: "Font Regular", sans-serif;
            font-size: 22px;
            text-align: center;
            p {
                margin: 0;
            }
            &:hover,
            &:focus {
                cursor: pointer;
                background: var(--white);
                color: var(--green-medium);
            }
            @media screen and (max-width: 768px) {
                font-size: 18px;
                width: 110px;
                height: 50px;
                font-size: 16px;
            }
        }
    }
    &-img {
        position: absolute;
        top: 0;
        right: 0;
        overflow: hidden;
        z-index: -1;
        @media screen and (max-width: 1500px) {
            right: -100px;
        }
        @media screen and (max-width: 1300px) {
            right: -200px;
        }
        @media screen and (max-width: 1100px) {
            right: -250px;
        }
        @media screen and (max-width: 991px) {
            position: inherit;
            width: 100%;
            border: none;
            border-radius: none;
            height: auto;
            margin-bottom: 3rem;
        }
        img {
            border-radius: 20px 0 0 20px;
            @media screen and (max-width: 991px) {
                border-radius: 20px;
                width: 100%;
                height: auto;
                border-radius: 0;
            }
        }
    }
}
.content-adhesion {
    margin-top: 14rem;
    @media screen and (max-width: 991px) {
        margin-top: 7rem;
    }
    &-title {
        text-align: left;
        @media (max-width: 991px) {
            padding: 0px 20px;
        }
        h1 {
            font-family: "Font Bold";
            font-size: 40px;
            color: var(--green-medium);
            margin-bottom: 0;
            @media screen and (max-width: 991px) {
                font-size: 24px;
            }
        }
    }
}
</style>
